// 校验函数

/**
 * 检查输入值是否为空
 * */ 
export const isEmpty = (value)=>{
  if(value) return true
  return false
}
/**
 * 检查输入值是否为数字或英文字符
 * */ 
export const  isAlphaNumeric = (value)=> {
  // 使用正则表达式检查输入值是否只包含数字和英文字符
  const reg = /^[a-zA-Z0-9]+$/;
  return reg.test(value);
};
/**
 * 检查输入值是否为数字或英文字符且长度不超过32位
 * */ 
export const isLength = (value, min, max) => {
  const reg = new RegExp('^[a-zA-Z0-9]{' + min + ',' + max + '}$');
  return reg.test(value);
};

/**
 * 检查输入值是否为数字或英文字符且长度 和 中文字符、字母和数字
 * */ 
export const isNameLength = (value, min, max) => {
  const reg = new RegExp('^[\u4e00-\u9fa5a-zA-Z0-9]{' + min + ',' + max + '}$');
  return reg.test(value);
};

/**
 * 正则表达式匹配中文字符、字母和数字，不包含特殊符号和表情符号
*/
export const isSpecialChar = (value) => {
  const reg = /^[\u4E00-\u9FA5A-Za-z0-9]+$/;
  return reg.test(value);
};

/**
 * 匹配手机号 手机号号码正则
*/
export const isPhoneNumber = (value) => {
  const reg = /^(?:(?:\+|00)86)?1[3-9]\d{9}$/;
  return reg.test(value);
};

/**
 * 匹配手机号验证码 手机号验证码正则
*/
export const isVerifyCode = (value) => {
  const reg = /^\d{4}$/;
  return reg.test(value);
};


/**
 * 匹配密码 需要包含数字、字母等超过8个字符
*/
export const isPassword = (value) => {
  const reg = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d.@$!%*?&]{8,}$/;
  return reg.test(value);
};

/**
 * 匹配密码或字符串是否一致 
*/
export function isPasswordsMatch(strone,strtwo) {
  return strone === strtwo;
}



// WEBPACK FOOTER //
// ./src/util/verify.js